var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import SelectSurveyForm from "./SelectSurveyForm";
import useUniqueId from "../../Hooks/useUniqueId";
import { AlertInfo, AlertSuccess, } from "../../UI/StandardAlerts/StandardAlerts";
import SurveyService from "../../../Services/Survey.service";
import useService from "../../Hooks/useService";
import PersonService from "../../../Services/Person.service";
import FilterService from "../../../Services/Filter.service";
const SendSurveyToPopulationModal = (_a) => {
    var { populationId, populationName, numStudentsReturnedByPopulation, onSend } = _a, modalProps = __rest(_a, ["populationId", "populationName", "numStudentsReturnedByPopulation", "onSend"]);
    const makeId = useUniqueId()[1];
    const [me, loadMe] = useService(PersonService.me);
    React.useEffect(() => {
        loadMe();
    }, [loadMe]);
    const [numStudentsReturnedByFilterInternal, setNumStudentsReturnedByFilterInternal,] = React.useState(null);
    React.useEffect(() => {
        if (modalProps.isOpen) {
            FilterService.getCountOfStudentsInFilter(populationId).then(setNumStudentsReturnedByFilterInternal);
        }
    }, [populationId, modalProps.isOpen]);
    const numStudentsInPopulationFinal = numStudentsReturnedByPopulation || numStudentsReturnedByFilterInternal;
    const defaultValue = React.useMemo(() => ({
        comment: `${me.data ? me.data.fullName : ""} sent a survey to a filter named ${populationName}`,
    }), [populationName, me.data]);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { keepModalOpenAfterSuccess: _jsx(AlertSuccess, { message: _jsxs(_Fragment, { children: ["Survey successfully sent to\u00A0", _jsx("strong", { children: populationName }), numStudentsInPopulationFinal != null ? (_jsxs(_Fragment, { children: ["\u00A0which has\u00A0", _jsx("strong", { children: numStudentsInPopulationFinal }), "\u00A0people."] })) : (".")] }) }), respondToDefaultValueChanges: true, modalTitle: "New Survey", saveButtonContents: () => "Send", confirmSubmit: numStudentsInPopulationFinal
            ? `You are sending this survey to a filter of ${numStudentsInPopulationFinal} students.  Are you sure you want to proceed?`
            : "You are sending this survey to a filter.  Are you sure you want to proceed?", defaultValue: defaultValue, handleSubmit: (state) => SurveyService.sendSurveyToPersonPopulation({
            surveyId: state.survey.id,
            populationId,
            comments: state.comment,
        }).then(() => {
            if (onSend) {
                onSend();
            }
        }), children: (useFormProps) => (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("filterName"), children: "Filter" }), _jsxs("div", { id: makeId("filterName"), children: [populationName, " ", numStudentsInPopulationFinal != null &&
                                    `(${numStudentsInPopulationFinal})`] })] }), _jsx(SelectSurveyForm, Object.assign({}, useFormProps)), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("comment"), children: "Comment" }), _jsx("textarea", { id: makeId("comment"), ref: useFormProps.register, name: "comment", className: "form-control" })] }), _jsx(AlertInfo, { message: "The survey results will appear on the Surveys tab corresponding to each recipient." })] })) })));
};
export default SendSurveyToPopulationModal;
